export default __webpack_public_path__ + "static/media/this-will-be-fun.12dfceba.gif";